$(window).on("scroll touchmove", function() {
    if ($(document).scrollTop() >= $("#thinking").position().top) {
        $('#header').addClass("toblack");
        $('body').addClass("dark");
    } else {
        $("#header").removeClass("toblack");
        $('body').removeClass("dark");
    }
});
function playVideo(videoElem) {
    const videoPromise = videoElem.play();
    if (videoPromise !== undefined) videoPromise.then(function() {}).catch(function(error) {
        console.log(`Error playing video - ${error}`);
    });
}
var video = document.getElementById("tahzoo-video");
$(video).one("click", function(e) {
    video.load(); // load resets video to 0
    video.muted = false;
    video.controls = "controls";
    //  video.currentTime = 0;
    playVideo(video);
});
$("#logo").click(function(e) {
    e.preventDefault();
    window.location.href = '/';
});
$("#toggle").click(function(e) {
    e.preventDefault();
    $("#header").toggleClass("on");
});
$(".whitepaper").click(function(e) {
    e.preventDefault();
    $(".whitepaper-gate").toggleClass("on");
});
$('.whitepaper-form').submit(function(evt) {
    evt.preventDefault();
    const whitepaperEl = $(this).parent('.whitepaper-gate');
    const formMsgEl = whitepaperEl.find('.form-msg');
    const hiddenInputs = $(this).get(0).querySelectorAll('input[type="hidden"]');
    const inputs = $(this).get(0).querySelectorAll('input:not([type=hidden]):not(#submit)');
    let requestObj = {
        fields: []
    };
    inputs.forEach((input)=>{
        requestObj.fields.push({
            objectTypeId: '0-1',
            name: input.name,
            value: input.value
        });
    });
    hiddenInputs.forEach((input)=>{
        requestObj[input.name] = input.value;
    });
    $.ajax({
        type: 'POST',
        url: '/api/form',
        data: JSON.stringify(requestObj),
        contentType: "application/json; charset=utf-8"
    }).done((data)=>{
        let response = null;
        response = JSON.parse(data);
        if (response.inlineMessage) formMsgEl.html(`<p>${response.inlineMessage}</p>`);
        if (response.whitepaperUrl) window.open(`${window.location.protocol}//${window.location.host}${response.whitepaperUrl}`, '_blank');
    });
});
$(".gate-close").click(function(e) {
    e.preventDefault();
    $(".whitepaper-gate").toggleClass("on");
});

//# sourceMappingURL=public.f90748ef.js.map
